import { differenceInMinutes } from "date-fns";

// Combine all proId and return as a string
const getProDetails = (data) => {
  return data.length > 0 ? data.map((pro) => pro.proId)?.join(", ") : "";
};

// Calculate the total value of each shipment key pass in a function
const totalValueGetter = (params, key) => {
  const { shipments } = params;
  return shipments.reduce((acc, shipment) => {
    return acc + shipment[key];
  }, 0);
};

/* Return formatted stop to display data
sampleFormat = {
  stopId: "",
  data: { stopId: "", stopType: "Delivery",... },
  actualNextStop: { stopId: "", stopSequence: ,... },
  isDeviation: true,
  plannedNextStop: { stopId: "", stopSequence: 0,... },
  plannedStops: [{ stopId: "", stopSequence: 0,... }],
} */
const getDeviationData = (routeData, stopIndex, terminalCode) => {
  if (routeData.stops.length > 0 && routeData.actualStops.length > 0) {
    const stopData = routeData.actualStops.find(
      (actualStops) => actualStops.stopSequence === stopIndex
    );
    if (stopData.stopId) {
      stopData.data = getStopComplianceData(stopData.stopId, routeData.stops);
    } else {
      stopData.data = {
        name: terminalCode,
        isTerminal: true,
        stopId: "terminal",
      };
    }
    if (stopData.actualNextStop) {
      stopData.actualNextStop.data = getStopComplianceData(
        stopData.actualNextStop.stopId,
        routeData.stops
      );
    }
    if (stopData.plannedNextStop) {
      stopData.plannedNextStop.data = getStopComplianceData(
        stopData.plannedNextStop.stopId,
        routeData.stops
      );
    }
    stopData.manifestNumber = routeData.manifestNumber;
    return stopData;
  }
  return null;
};

//Return planned stop list
const getPlannedStopData = (routeData, stopIndex, color) => {
  const stopData = routeData.actualStops.find(
    (actualStops) => actualStops.stopSequence === stopIndex
  );

  if (stopData.stopId) {
    stopData.data = getStopComplianceData(stopData.stopId, routeData.stops);
  }
  if (stopData.plannedStops.length > 0) {
    stopData.plannedStops = stopData.plannedStops.map((plannedStop) => {
      const newData = routeData.stops.find(
        (stops) => stops.stopId === plannedStop.stopId
      );
      if (newData) {
        plannedStop.latitude = newData.latitude;
        plannedStop.longitude = newData.longitude;
        plannedStop.name = newData.name;
      }
      return plannedStop;
    });
  }
  stopData.color = color;
  stopData.routeId = `planned-${routeData.routeId}`;
  return stopData;
};

//Return stop which has deviation for route
const getRouteDeviationData = (routeData, terminalCode) => {
  if (routeData.stops.length > 0 && routeData.actualStops.length > 0) {
    return routeData.actualStops
      .map((actualStops) => {
        if (actualStops.isDeviation) {
          return getDeviationData(
            routeData,
            actualStops.stopSequence,
            terminalCode
          );
        }
      })
      .filter((x) => x);
  }
  return [];
};

//Return Stop Compliance based on stopId
const getStopComplianceData = (stopId, stops) => {
  return stops.find((stop) => stop.stopId === stopId);
};

//Return formatted Customer Name sting
const returnCustomerName = (data) => {
  return `${data.name}, ${data.city}, ${data.state}`;
};

//Return actual stop list
const getActualStopData = (routeData, terminalLocation, color) => {
  return {
    stops: routeData.actualStops.map((stop) => {
      const data = getStopComplianceData(stop.stopId, routeData.stops) || {
        latitude: terminalLocation.lat,
        longitude: terminalLocation.lng,
        isTerminal: true,
      };
      return {
        stopId: stop.stopId,
        stopSequence: stop.stopSequence,
        ...data,
      };
    }),
    color: color,
    routeId: `actual-${routeData.routeId}`,
  };
};

//Format min into "H [hr] m [min]" formate
const FormatMinutesIntoTimeString = (minutes) => {
  let formattedValue;
  const mins = minutes < 0 ? Math.abs(minutes) : minutes;
  if (mins >= 60) {
    formattedValue = `${Math.floor(mins / 60)} hr ${mins % 60} min`;
  } else {
    formattedValue = `${mins} min`;
  }
  return minutes < 0 ? `-${formattedValue}` : formattedValue;
};

const formateDigit = (digit) => {
  return digit > 9 ? digit : "0" + digit;
};

//Format min into "HH:MM" formate
const convertMinutesToHHMM = (minutes) => {
  let formattedValue;
  const mins = minutes < 0 ? Math.abs(minutes) : minutes;
  if (mins >= 60) {
    formattedValue =
      formateDigit(Math.floor(mins / 60)) + ":" + formateDigit(mins % 60);
  } else {
    formattedValue = "00:" + formateDigit(mins);
  }
  return minutes < 0 ? `-${formattedValue}` : formattedValue;
};

const getTimeDifferenceInMinutes = (departureTime, arrivalTime) => {
  if (departureTime && arrivalTime) {
    const departureTimeArray = departureTime.split(":");
    const arrivalTimeArray = arrivalTime.split(":");
    return differenceInMinutes(
      new Date(0, 0, 0, departureTimeArray[0], departureTimeArray[1], 0),
      new Date(0, 0, 0, arrivalTimeArray[0], arrivalTimeArray[1], 0)
    );
  } else {
    return 0;
  }
};

export {
  getProDetails,
  totalValueGetter,
  getRouteDeviationData,
  getPlannedStopData,
  getDeviationData,
  returnCustomerName,
  getActualStopData,
  FormatMinutesIntoTimeString,
  getTimeDifferenceInMinutes,
  convertMinutesToHHMM,
};
